// extracted by mini-css-extract-plugin
export default {"coverSpin":"Loader_coverSpin__WAJOv","spin":"Loader_spin__I0Tfd"};